module.exports = __webpack_public_path__ + "img/icon_coupon.4e42020f.png";